import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_59g989rcu2: FaireBrandEntity = {
  token: "b_59g989rcu2",
  type: "brand",
  name: "Life & Apples",
  avatarUrl:
    "https://cdn.faire.com/fastly/714219361bbf7083f8938a2c54bbdb114943e42d12900b10f3b4d46deb1ca170.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1f52910d7cdbd1537ad0c86a4b7aa3eba5415c7baf12aaf7e7ece4c1f5e83854.png",
  logoUrl:
    "https://cdn.faire.com/fastly/714219361bbf7083f8938a2c54bbdb114943e42d12900b10f3b4d46deb1ca170.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1f52910d7cdbd1537ad0c86a4b7aa3eba5415c7baf12aaf7e7ece4c1f5e83854.png",
  location: "Sheridan, WY, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Life & Apples planners are guided motivational journals for simplifying daily routines. Our collection features gratitude journals, meal planners, wellness journals, mental health journals, recipe notebooks and more tools for healthy happy living.\nLife & Apples planners and journals are sustainably crafted and make wonderful gifts for any holiday and occasion.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:48.133Z",
    importedBy: "entity-db-cli",
  },
};
